<script setup lang="ts">
import {ref} from "vue";
import {ReelCate} from "@/types";
import {TestService} from "@/api/api.ts";

const oneCateList = ref<ReelCate>()
const twoCateList = ref<ReelCate>()
const threeCateList = ref<ReelCate>()

const oneCateId = ref<number>()
const twoCateId = ref<number>()
const threeCateId = ref<number>()


const getReelCate = async (cateId: number) => {
  try {
    const res = await TestService.getReelCateList({
      cate_id: cateId
    })
    if (res.data.code === 200) {
      oneCateId.value = undefined
      twoCateId.value = undefined
      threeCateId.value = undefined
      if (res.data.data) {
        if (res.data.data.length > 0) {
          oneCateList.value = res.data.data[0]
        } else {
          oneCateList.value = undefined
        }
        if (res.data.data.length > 1) {
          twoCateList.value = res.data.data[1]
        } else {
          twoCateList.value = undefined
        }
        if (res.data.data.length > 2) {
          threeCateList.value = res.data.data[2]
        } else {
          threeCateList.value = undefined
        }
      }
    }
  } catch (err) {
    console.warn(err)
  } finally {
  }
}

const getOneCateId = () => {
  return oneCateId.value
}

const getTwoCateId = () => {
  return twoCateId.value
}

const getThreeCateId = () => {
  return threeCateId.value
}

const resetReelCateList = () => {
  oneCateList.value = undefined
  twoCateList.value = undefined
  threeCateList.value = undefined
  oneCateId.value = undefined
  twoCateId.value = undefined
  threeCateId.value = undefined
}

defineExpose({
  getReelCate, getOneCateId, getTwoCateId, getThreeCateId, resetReelCateList
})
</script>

<template>
  <el-form-item label-position="right" label="套卷分类一" v-if="oneCateList && oneCateList.list && oneCateList.list.length > 0">
    <el-select class="my-selector" v-model="oneCateId" placeholder="请选择分类一">
      <el-option
          v-for="item in oneCateList?.list"
          :key="item.id" :label="item.name" :value="item.id">
      </el-option>
    </el-select>
  </el-form-item>
  <el-form-item label-position="right" label="套卷分类二" v-if="twoCateList && twoCateList.list && twoCateList.list.length > 0">
    <el-select class="my-selector" v-model="twoCateId" placeholder="请选择分类二">
      <el-option
          v-for="item in twoCateList?.list"
          :key="item.id" :label="item.name" :value="item.id">
      </el-option>
    </el-select>
  </el-form-item>
  <el-form-item label-position="right" label="套卷分类三" v-if="threeCateList && threeCateList.list && threeCateList.list.length > 0">
    <el-select class="my-selector" v-model="threeCateId" placeholder="请选择分类三">
      <el-option
          v-for="item in threeCateList.list"
          :key="item.id" :label="item.name" :value="item.id">
      </el-option>
    </el-select>
  </el-form-item>
</template>

<style scoped>
</style>
